/**
 * API base URL for frontend → backend requests.
 *
 * - `same-origin` or empty — Vite proxies API paths to SAM (recommended local default;
 *   keeps the HttpOnly refresh cookie first-party so Chrome does not log you out on refresh).
 * - `http://localhost:3000` — browser talks to SAM directly (cross-origin; cookies often blocked).
 * - `https://….trycloudflare.com` — separate API tunnel (cross-origin; SAM local CORS is often unreliable).
 */

const configured = import.meta.env.VITE_API_BASE_URL;

const DEFAULT_LOCAL_API = 'http://localhost:3000';

export function getApiBaseUrl(): string {
  if (configured === undefined || configured === null) {
    return DEFAULT_LOCAL_API;
  }
  const trimmed = String(configured).trim();
  if (trimmed === '' || trimmed === 'same-origin') {
    return '';
  }
  return trimmed.replace(/\/$/, '');
}

/** Full URL for an API path (path must start with `/`). */
export function apiFetchUrl(path: string): string {
  const base = getApiBaseUrl();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalizedPath}` : normalizedPath;
}

/** Throws in production when VITE_API_BASE_URL is missing; warns in dev. */
export function assertApiConfigured(): void {
  if (configured !== undefined && configured !== null) return;
  if (import.meta.env.PROD) {
    throw new Error('VITE_API_BASE_URL is not set. Set it for production builds.');
  }
  console.warn('VITE_API_BASE_URL is not set — falling back to http://localhost:3000.');
}
